import React from 'react'
import Signet from '../../../assets/logo/neoskop-logo.svg'
import './styles.scss'

const Logo = () => (
  <div className="logo">
    <Signet />
  </div>
)

export default Logo
